<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
         <div>
              <CourseRegistrationSearchSidebar :isSidebarActive="showSearchSidebar" @closeSearchSidebar="closeSearchSidebar"  :search="search"/>
           </div>

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="courseRegistrations" v-if="!addNewDataSidebar">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

       <div class="vx-row" v-if="!$acl.check('trainee')">
          <vs-button type="border" icon-pack="feather" icon="arrow-left"  :to="{name: 'MainCourseRegistration'}">{{$t('Back')}}</vs-button>
          <vs-button type="border" class="ml-5" icon-pack="feather" icon="icon-plus" :to="{name: 'CourseRegistration-add/Edit'}">{{$t('AddNew')}}</vs-button>
          <vs-button type="border" class="ml-5" icon-pack="feather" icon="icon-search" @click="toggleSearchSidebar(true)">{{$t('Search')}}</vs-button>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ courseRegistrations.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : courseRegistrations.length }} of {{ courseRegistrations.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="Name">{{$t('CourseStartDate')}}</vs-th>
         <vs-th sort-key="Name">{{$t('Course')}} </vs-th>
          <vs-th sort-key="Name" v-if="!$acl.check('trainee')">{{$t('Trainee')}} </vs-th>
          <vs-th sort-key="Name"> {{$t('CurrentStatus')}}</vs-th>
        <vs-th>{{$t('Action')}}</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.stop="editData(tr.ID)" :to="{name: 'CourseRegistration-add/Edit', params: { ID: tr.ID}}">
                 <vs-td>
                <p class="product-name font-medium truncate">{{ tr.CourseStartDate.split("T")[0]  }}</p>
              </vs-td>
             <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Course.Name }}</p>
              </vs-td>
               <vs-td v-if="!$acl.check('trainee')">
                <p class="product-name font-medium truncate">{{ tr.Trainee.FullName }}</p>
              </vs-td>
                 <vs-td>
                <p class="product-name font-medium truncate" :style="{'background-color':tr.Status.ColorCode}">{{ tr.Status.Name }}</p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <router-link :to="{name: 'CourseRegistration-add/Edit', params: { ID: tr.ID}}" svgClasses="w-5 h-5 hover:text-primary stroke-current"> <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"  /></router-link>

                 <feather-icon v-if="!$acl.check('trainee')" icon="PrinterIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="PrintFrom(tr)"/>

                  <feather-icon class="ml-2" v-if="$acl.check('trainee')" @click.stop="showStatus(tr)" icon="LayersIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"  />
              </vs-td>
            </tr>
          </tbody>
        </template>
    </vs-table>

  </div>
</template>


<script>
import vSelect from 'vue-select'

import moduleCourseRegistration from "@/store/courseRegistration/moduleCourseRegistration.js";
import CourseRegistrationSearchSidebar from './CourseRegistrationSearchSidebar.vue'
import moduleCourse from "@/store/course/moduleCourse.js";
import moduleTrainee from "@/store/user/trainee/moduleTrainee.js";
import moduleCustomer from "@/store/user/customer/moduleCustomer.js";
import moduleStatus from "@/store/settings/status/moduleStatus.js";
export default {
  components: {
  CourseRegistrationSearchSidebar,
     vSelect,
  },
  data() {
    return {
      activePrompt:false,
      selected: [],

      itemsPerPage: 10,
      isMounted: false,
      first:true,
      search:{},
       showSearchSidebar: false,
      // Data Sidebar
      addNewDataSidebar: false,

      rowDataForDelete: {},
      activeConfirm: false
    };
  },
  computed: {
    // currentPage() {
    //   if (this.isMounted) {
    //     return this.$refs.table.currentx;
    //   }
    //   return 0;
    // },
  currentPage() {
      debugger
      if (this.isMounted) {
          if(!this.first)
            this.$store.state.courseRegistrationList.search.pageNum=this.$refs.table.currentx;
         this.first=false;
          return this.$refs.table.currentx;
      }
      return 0;
    },
    courseRegistrations() {

      return this.$store.state.courseRegistrationList.courseRegistrations;
    }
  },

  methods: {
     PrintFrom(data)
  {
       window.open('#/Report/RegistrationForm/'+data.ID+"/"+data.TraineeID, '_blank');
  },
  showStatus(data)
  {
         window.open('#/RegistrationStatus/'+data.Code, '_blank');
  },
   editData(ID)
   {
         this.$router.push({name: 'CourseRegistration-add/Edit', params: { ID: ID}});
   },

     toggleSearchSidebar(val) {
      debugger
      this.showSearchSidebar = val;
    },

    closeSearchSidebar(search) {
    debugger
    if(search)
    {
       this.searchCourseRegistration();
    }

     this.showSearchSidebar = false;
    },

  searchCourseRegistration(){

     var vm=this;
     this.$vs.loading();
         this.$store.dispatch("courseRegistrationList/searchCourseRegistration",  this.search).then(()=>{
             this.$vs.loading.close();
              vm.$refs.table.currentx=vm.$store.state.courseRegistrationList.search.pageNum;
        }).catch(()=>{
                this.$vs.loading.close();
              });
        //  this.$store.dispatch("courseRegistrationList/searchCourseRegistration",  this.search).catch(err => {
        //           console.error(err);
        //         });
    },

    deleteData(data) {

      this.$store.dispatch("courseRegistrationList/removeItem", data).catch(err => {
        console.error(err);
      });
    },


    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm") ,
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlert
      });
    },

    acceptAlert() {

      this.deleteData(this.rowDataForDelete);
      this.$vs.notify({
        color: "danger",
        title: this.$t("Deletedrecord"),
 text: this.$t("Theselectedrecordwassuccessfullydeleted")      });
    },


  },

  created() {
   if (!moduleCourseRegistration.isRegistered) {
      this.$store.registerModule("courseRegistrationList", moduleCourseRegistration);
      moduleCourseRegistration.isRegistered = true;
    }

    if (!moduleStatus.isRegistered) {
      this.$store.registerModule("StatusList", moduleStatus);
      moduleStatus.isRegistered = true;
    }
    if( this.$store.state.StatusList.Statuses.length==0)
       this.$store.dispatch("StatusList/gatAllRegistrationStatus");

    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
  if(this.$store.state.courseList.courses.length==0)
      this.$store.dispatch("courseList/fetchDataListItems");

    if (!moduleTrainee.isRegistered) {
      this.$store.registerModule("traineeList", moduleTrainee);
      moduleTrainee.isRegistered = true;
    }
    this.$store.dispatch("traineeList/fetchDataListItems");

    if (!moduleCustomer.isRegistered) {
      this.$store.registerModule("customerList", moduleCustomer);
      moduleCustomer.isRegistered = true;
    }


    if(this.$acl.check('trainee'))
    {
       this.$store.dispatch("courseRegistrationList/GetCourseRegistrationsByTraineeID");
    }
    else
    {
        // this.search.StartDate= new Date().getFullYear()+"/01/01";
        // this.search.EndDate=new Date().getFullYear()+"/12/31";

		this.search.CourseID= this.$route.params.CourseID;
		if(this.$route.params.CourseClassID!="null")
           this.search.CourseClassID= this.$route.params.CourseClassID;
		if(this.$route.params.AnnualPlanID!="null")
          this.search.AnnualPlanID= this.$route.params.AnnualPlanID;
        this.searchCourseRegistration();
    }
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
